import { useSignal } from "@preact/signals";
import { fetchOrError } from "@/app/utils.ts";
import { useEffect } from "preact/hooks";
import { useAppData } from "@/components/App.tsx";

export function SettingsUI() {
  const appData = useAppData();

  function logout() {
    document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    location.href = appData.siteURL;
  }

  return <dialog class="settings" open={false}>
    <div class="container">
      <form method='dialog'>
        <span>Settings</span>
        <button type="submit" class="close"></button>
      </form>

      <form>
        <fieldset>
          <legend>{appData.user.value?.name} ({appData.user.value?.email})</legend>
          <button onClick={logout} type="button">Logout</button>
        </fieldset>
      </form>

      {appData.user.value?.is_admin && (<>
        <form action="/api/create-user" method="post" target="_blank">
          <fieldset>
            <legend>Create User</legend>
            <input type="text" name="name" placeholder="Name" />
            <input type="email" name="email" placeholder="Email" />
            <button type="submit">Create</button>
          </fieldset>
        </form>

        <form action="/api/reset-password" method="post" target="_blank" >
          <fieldset>
            <legend>Password Reset</legend>
            <input type="email" name="email" placeholder="Email" required />
            <button type="submit">Reset Password</button>
          </fieldset>
        </form>
      </>
      )}


    </div>
  </dialog>
}